var _circle, _circle2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmallPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6621_10988)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#060921"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6621_10988",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 12,
    height: 12
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.99939,
    cy: 5.00085,
    r: 5.73718,
    fill: "#060921"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6621_10988)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6621_10988)",
    filter: "url(#filter0_d_6621_10988)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4744,
    height: 11.4744,
    transform: "translate(-0.737793 -0.736328)",
    fill: "#32F6DB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6621_10988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59407 5.00034C9.59407 2.46437 7.53826 0.408561 5.00229 0.408561C2.46632 0.408561 0.410514 2.46437 0.410514 5.00034C0.410514 7.53631 2.46632 9.59212 5.00229 9.59212V10.0144C2.23313 10.0144 -0.0117188 7.7695 -0.0117188 5.00034C-0.0117188 2.23118 2.23313 -0.0136719 5.00229 -0.0136719C7.77146 -0.0136719 10.0163 2.23118 10.0163 5.00034C10.0163 7.7695 7.77146 10.0144 5.00229 10.0144V9.59212C7.53826 9.59212 9.59407 7.53631 9.59407 5.00034Z",
    fill: "#050B29"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6621_10988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27415 7.88165C4.45333 7.88165 4.59911 7.73587 4.59911 7.5567V2.448C4.59911 2.26883 4.45333 2.12305 4.27415 2.12305H3.17042C2.99124 2.12305 2.84546 2.26883 2.84546 2.448V7.55667C2.84546 7.73585 2.99124 7.88163 3.17042 7.88163L4.27415 7.88165Z",
    fill: "#050B29"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6621_10988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98498 3.211C7.07781 3.211 7.15306 3.13577 7.15306 3.04292V2.448C7.15306 2.26883 7.00728 2.12305 6.82811 2.12305H5.72437C5.5452 2.12305 5.39941 2.26883 5.39941 2.448V7.55667C5.39941 7.73585 5.5452 7.88163 5.72437 7.88163H6.82811C7.00728 7.88163 7.15306 7.73585 7.15306 7.55667V2.96142C7.15306 2.86858 7.07781 2.79334 6.98498 2.79334C6.89216 2.79334 6.8169 2.86858 6.8169 2.96142C6.8169 3.07538 6.83727 3.211 6.98498 3.211Z",
    fill: "#050B29"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6621_10988",
    x: -1.40076,
    y: -1.39929,
    width: 12.8003,
    height: 12.8005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.331482
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6621_10988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6621_10988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6621_10988",
    x: -0.674682,
    y: -0.676635,
    width: 11.354,
    height: 11.3533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.331482
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6621_10988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6621_10988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6621_10988",
    x: 2.1825,
    y: 1.46008,
    width: 3.07959,
    height: 7.08374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.331482
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6621_10988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6621_10988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6621_10988",
    x: 4.73645,
    y: 1.46008,
    width: 3.07959,
    height: 7.08374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.331482
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6621_10988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6621_10988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6621_10988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6621_10988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4744,
    height: 11.4744,
    fill: "white",
    transform: "translate(-0.737793 -0.736328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallPause);
export default __webpack_public_path__ + "static/media/icon-small-pause.91320f0a1b3d0bab07f743b3cb3d177d.svg";
export { ForwardRef as ReactComponent };